import { render, staticRenderFns } from "./CharacterInfo.vue?vue&type=template&id=d4146b2c&scoped=true"
import script from "./CharacterInfo.vue?vue&type=script&lang=ts"
export * from "./CharacterInfo.vue?vue&type=script&lang=ts"
import style0 from "./CharacterInfo.vue?vue&type=style&index=0&id=d4146b2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4146b2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4146b2c')) {
      api.createRecord('d4146b2c', component.options)
    } else {
      api.reload('d4146b2c', component.options)
    }
    module.hot.accept("./CharacterInfo.vue?vue&type=template&id=d4146b2c&scoped=true", function () {
      api.rerender('d4146b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/CharacterInfo.vue"
export default component.exports